import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import { GroupPreview } from './group-preview'
import { handleOnDragEnd } from "../../store/board.actions"

import { useRef } from 'react'


export function GroupList({customHeight, board, groups = [], users = [] }) {
    const containerRef = useRef()

    function getCellWidth() {
        // return board.cmpsOrder.reduce((acc, cmpOrder) => {
        //     if (cmpOrder === 'person') acc += 87
        //     else acc += 139
        //     return acc
        // }, 600)
        return 2700;
    }

    if (!groups) return <div></div>
    
    return <div ref={containerRef} style={{ minWidth: getCellWidth() }}>
        {/* <DragDropContext onDragEnd={(ev) => handleOnDragEnd(ev, board)}>
            <Droppable droppableId={board._id} type='group'> */}
                {/* {(droppableProvided) => {
                    return 
                }} */}

                    {/* <section ref={droppableProvided.innerRef}{...droppableProvided.droppableProps} className="group-list"> */}
                    <section className="group-list" >
                        <ul>
                            {groups.map((group, idx) => {
                                return (<li key={idx}><GroupPreview customHeight={customHeight} idx={idx} group={group} board={board} users={users}  /></li>)
                            })}
                        </ul>
                    </section>
            {/* </Droppable>
        </DragDropContext> */}
    </div>
}